<ion-content [fullscreen]="true">



<div class="container">
 
  <div style="width: 100%; margin-bottom: 30px;">
    <img style="width: 250px;" src="assets/icon/common/altomate_logo.png" alt="">
  </div>


  <h1>Updating App</h1>
  <p class="subtitle">Please wait while we download the latest version</p>
  
  <div *ngIf="percentage !== -1" class="progress-container">
   
      <ion-progress-bar style="margin-bottom: 8px;" [value]="percentage / 100"></ion-progress-bar>
      
      <div class="progress-percentage">{{ percentage }}%</div>
  </div>
  
  <p *ngIf="percentage !== 100 && percentage !== -1" class="status-text">Downloading update files...</p>
  
  <div *ngIf="percentage === -1" class="error-container">
      <div class="error-text">Download failed. Please check your connection and try again.</div>
  </div>
  
  <div *ngIf="percentage === 100" class="installing-animation">
      <div class="spinner"></div>
      <span class="status-text">Installing update<span class="installing-dots"></span></span>
  </div>
  
  <button (click)="retryUpdate()" *ngIf="percentage === -1" class="action-button" id="retry-button">Try Again</button>
  
  <p class="remark">The app will automatically update once the download is complete. Please do not close the app during this process.</p>
</div>
</ion-content>